import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

const ResourceLibraryStyleOptionsSchema = z.object({
  backgroundColor: z.string().optional(),
});

const ResourceLibraryOptionsSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  preheaderEnabled: z.boolean().optional(),
  subheaderEnabled: z.boolean().optional(),
  entryCount: z.number().optional(),
  style: ResourceLibraryStyleOptionsSchema.optional(),
  layout: z.string().optional(),
});

const ResourceLibraryTopLevelPreheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

const ResourceLibraryTopLevelHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const ResourceLibraryTopLevelSubheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});

const ResourceLibraryHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const ResourceLibraryDescriptionFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('description'),
  role: z.literal(FieldRole.Description),
});

const ResourceLibraryImageFieldSchema = ImageFieldSchema.extend({
  name: z.literal('image'),
  role: z.literal(FieldRole.Image),
});

const ResourceLibraryLinkFieldSchema = UrlFieldSchema.extend({
  name: z.literal('link'),
  role: z.literal(FieldRole.Url),
});

const ResourceLibraryTopLevelFieldSchema = z.discriminatedUnion('name', [
  ResourceLibraryTopLevelPreheaderFieldSchema,
  ResourceLibraryTopLevelHeaderFieldSchema,
  ResourceLibraryTopLevelSubheaderFieldSchema,
]);

const ResourceLibraryFieldSchema = z.discriminatedUnion('name', [
  ResourceLibraryHeaderFieldSchema,
  ResourceLibraryDescriptionFieldSchema,
  ResourceLibraryImageFieldSchema,
  ResourceLibraryLinkFieldSchema,
]);

const ResourceLibraryTopLevelFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(ResourceLibraryTopLevelFieldSchema),
});

const ResourceLibraryResourceFieldsGroupSchema = FieldGroupSchema.extend({
  fields: z.array(ResourceLibraryFieldSchema),
});

export const ResourceLibraryBlockConfigSchema = z.object({
  options: ResourceLibraryOptionsSchema,
  type: z.literal(BlockType.ResourceLibrary),
  fieldGroups: z.tuple([ResourceLibraryTopLevelFieldGroupSchema]).rest(ResourceLibraryResourceFieldsGroupSchema),
  version: z.literal(1),
});
